/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShockProfile
 */
export interface ShockProfile {
    /**
     * 
     * @type {string}
     * @memberof ShockProfile
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof ShockProfile
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ShockProfile
     */
    updatedAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ShockProfile
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShockProfile
     */
    versionId: string;
    /**
     * 
     * @type {string}
     * @memberof ShockProfile
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof ShockProfile
     */
    light: number;
    /**
     * 
     * @type {number}
     * @memberof ShockProfile
     */
    medium: number;
    /**
     * 
     * @type {number}
     * @memberof ShockProfile
     */
    severe: number;
    /**
     * 
     * @type {number}
     * @memberof ShockProfile
     */
    duration: number;
    /**
     * 
     * @type {number}
     * @memberof ShockProfile
     */
    xAxisScale: number;
    /**
     * 
     * @type {number}
     * @memberof ShockProfile
     */
    yAxisScale: number;
    /**
     * 
     * @type {number}
     * @memberof ShockProfile
     */
    zAxisScale: number;
}

/**
 * Check if a given object implements the ShockProfile interface.
 */
export function instanceOfShockProfile(value: object): value is ShockProfile {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    if (!('versionId' in value) || value['versionId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('light' in value) || value['light'] === undefined) return false;
    if (!('medium' in value) || value['medium'] === undefined) return false;
    if (!('severe' in value) || value['severe'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('xAxisScale' in value) || value['xAxisScale'] === undefined) return false;
    if (!('yAxisScale' in value) || value['yAxisScale'] === undefined) return false;
    if (!('zAxisScale' in value) || value['zAxisScale'] === undefined) return false;
    return true;
}

export function ShockProfileFromJSON(json: any): ShockProfile {
    return ShockProfileFromJSONTyped(json, false);
}

export function ShockProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShockProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'deleted': json['deleted'],
        'versionId': json['versionId'],
        'label': json['label'],
        'light': json['light'],
        'medium': json['medium'],
        'severe': json['severe'],
        'duration': json['duration'],
        'xAxisScale': json['xAxisScale'],
        'yAxisScale': json['yAxisScale'],
        'zAxisScale': json['zAxisScale'],
    };
}

export function ShockProfileToJSON(json: any): ShockProfile {
    return ShockProfileToJSONTyped(json, false);
}

export function ShockProfileToJSONTyped(value?: ShockProfile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'deleted': value['deleted'],
        'versionId': value['versionId'],
        'label': value['label'],
        'light': value['light'],
        'medium': value['medium'],
        'severe': value['severe'],
        'duration': value['duration'],
        'xAxisScale': value['xAxisScale'],
        'yAxisScale': value['yAxisScale'],
        'zAxisScale': value['zAxisScale'],
    };
}

